import { OrdersQueryParams } from "@shared/src/components/modules/orders/use-p2p-orders";
import type { GetAdsParams } from "@shared/src/services/ads.service";
import type { LedgerQuery } from "@sdk/shared/types/merchant-ledger.types";

export const ORDER_QUERY_KEY = (orderId: string) => ["order", orderId] as const;
export const ORDER_STATE_QUERY_KEY = (orderId: string) => ["order-state", orderId] as const;
export const ADS_QUERY_KEY = (params: GetAdsParams) => ["p2p-ads", params];
export const AD_QUERY_KEY = (adId: string | number) => ["ad", adId];
export const QUICK_TRADE_WAIT_TIME_KEY = ["quick-trade-wait-time"];

export const CHAIN_ID_KEY = "chainId";
export const USER_PAYMENT_CONFIGS_QUERY_KEY = (address: string) => ["userPaymentConfigs", address] as const;
export const P2P_ORDERS_QUERY_KEY = (params: Partial<OrdersQueryParams>) => ["p2p-orders", params] as const;

// Merchant Ledger Query Keys
export const MERCHANT_LEDGER_QUERY_KEY = (merchantId: string) => ["merchant-ledger", merchantId] as const;
export const MERCHANT_BALANCES_QUERY_KEY = (merchantId: string) => ["merchant-balances", merchantId] as const;
export const LEDGER_TRANSACTIONS_QUERY_KEY = (query: LedgerQuery) => ["ledger-transactions", query] as const;
export const MERCHANT_ANALYTICS_QUERY_KEY = (merchantId: string, period: string) =>
  ["merchant-analytics", merchantId, period] as const;
export const BALANCE_ALERTS_QUERY_KEY = (merchantId: string) => ["balance-alerts", merchantId] as const;

// Telegram
export const TELEGRAM_REGISTERED_QUERY_KEY = ["telegram-registered"] as const;
// Simplified auto ad query type
interface AutoAdQuery {
  page: number;
  limit: number;
  orderBy?: string;
  orderDirection?: "asc" | "desc";
  includePerformance?: boolean;
}

export const NATIVE_BALANCE_QUERY_KEY = (address: string, chainId: number) =>
  ["nativeBalance", address, chainId] as const;

export const ERC20_BALANCE_QUERY_KEY = (address: string, chainId: number, tokenAddress: string) =>
  ["erc20Balance", { address, chainId, tokenAddress }] as const;

export const ERC20_DECIMALS_QUERY_KEY = (tokenAddress: string, chainId: number, address: string) =>
  ["erc20Decimals", tokenAddress, chainId, address] as const;

export type P2POrdersQueryKey = ReturnType<typeof P2P_ORDERS_QUERY_KEY>;
export type OrderQueryKey = ReturnType<typeof ORDER_QUERY_KEY>;
export type OrderStateQueryKey = ReturnType<typeof ORDER_STATE_QUERY_KEY>;
export const KYC_STATUS_QUERY_KEY = (userId: number) => ["kyc-status", userId] as const;

// Analytics
export const ANALYTICS_OVERVIEW_QUERY_KEY = (filters: unknown) => ["analytics-overview", filters] as const;

// Merchant Ledger Query Key Types
export type MerchantLedgerQueryKey = ReturnType<typeof MERCHANT_LEDGER_QUERY_KEY>;
export type MerchantBalancesQueryKey = ReturnType<typeof MERCHANT_BALANCES_QUERY_KEY>;
export type LedgerTransactionsQueryKey = ReturnType<typeof LEDGER_TRANSACTIONS_QUERY_KEY>;

// Auto-Trader Query Keys
export const AUTO_TRADER_STATUS_KEY = ['autotrader', 'status'] as const;
export const AUTO_TRADER_APPLICATION_KEY = ['autotrader', 'application'] as const;
export const ADMIN_AUTOTRADER_APPLICATIONS_KEY = (filters: any) => 
  ['admin', 'autotrader', 'applications', filters] as const;
export const ADMIN_AUTOTRADER_STATS_KEY = ['admin', 'autotrader', 'stats'] as const;
